// extracted by mini-css-extract-plugin
module.exports = {"notices":"RestItemPageFormat_notices__TaGnC","wrapper":"RestItemPageFormat_wrapper__GC2E_","gigass":"RestItemPageFormat_gigass__dGdLJ"};